var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.1 18.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #606060;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.73,8.15c.51-.42,1.02-.86,1.53-1.28.67-.57,1.35-1.13,2.02-1.71.48-.41.94-.82,1.42-1.23.69-.59,1.39-1.18,2.09-1.77.64-.55,1.28-1.09,1.9-1.66.69-.63,1.5-.68,2.05-.07.49.55.53,1.39-.19,1.98-.51.41-.99.86-1.49,1.29-.67.57-1.35,1.14-2.02,1.71-.5.43-.99.87-1.49,1.29-.65.55-1.3,1.09-1.95,1.65-.41.35-.8.71-1.22,1.07.69.58,1.36,1.13,2.01,1.69.48.41.96.84,1.44,1.25.68.59,1.38,1.16,2.06,1.75.49.42.97.85,1.46,1.27.38.33.78.63,1.15.97.37.34.6.77.51,1.28-.1.6-.52.97-1.01,1.07-.52.11-.94-.06-1.31-.37-.66-.57-1.31-1.15-1.97-1.72-.78-.67-1.57-1.31-2.35-1.98-.66-.56-1.3-1.14-1.95-1.7-.79-.68-1.6-1.34-2.39-2.03-.28-.24-.61-.47-.79-.77-.44-.75-.25-1.37.49-1.98Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.8447e22c0adc6a4bbb652ee96d8023b3.svg";
export { ForwardRef as ReactComponent };